<template lang="pug">

  section.thanks
    .container
      .loading(v-if="loading && !submitted" key="loading")
        Circle9
      .submitted(v-if="submitted" key="submitted")
        h1 ¡Gracias!
      .form(v-if="!loading" key="form")
        h1 {{getScore.percentage}}%
        .percentage
          h2.number {{getScoreTexts.title}}
          h3.quote {{getScoreTexts.quote}}
        Sharer(:title="`Obtuve ${getScore.percentage}% : ${getScoreTexts.title} - ¿Cuánto sabes de Fórmula E? - MTOnline La Tercera`" :content="getScoreTexts.quote" v-if="!loading || submitted")
        p Ingresa tus datos para participar
        iframe(src="https://www.surveygizmo.com/s3/4786310/Formula-E", frameborder="0" width="300" height="600")

</template>

<script>
  import { mapGetters } from 'vuex'
  import { Circle9 } from 'vue-loading-spinner'
  import Sharer from '@/components/trivia/Sharer'

  export default  {
    name: 'thanks',
    components: {
      Circle9,
      Sharer
    },
    data: () => ({
      loading: false,
      submitted: false
    }),
    mounted(){
      this.$ga.event('trivia', 'finished', this.getScoreTexts.number)
    },
    computed: {
      ...mapGetters([
        'getScoreTexts',
        'getScore'
      ])
    }
}
</script>

<style scoped lang="scss">
  .thanks {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100%;
  }
  .container{
    text-align: center;
  }
  form{
    display: flex;
    align-items: stretch;
    justify-content: center;
    input{
      font-size: 1.6rem;
      padding: 1rem;
      border: 1px solid red;
      background-color: white;
      @media screen and (max-width: 500px){
        width: 50%;
      }
    }
    button{
      font-size: 1rem;
      padding: 1rem 2rem;
      background-color: red;
      color: black;
      border: 1px solid black;
      letter-spacing: 0.2rem;
      cursor: pointer;
    }
  }
  h1{
    text-align: center;
    font-family: 'Oswald', sans-serif;
    @include fluid-type(360px,
      1440px,
      42px,
      50px);
    line-height: 100%;
  }
  h2{
    font-family: 'Oswald', sans-serif;
    @include fluid-type(360px,
      1440px,
      26px,
      36px);
    line-height: 100%;
  }
  h3{
    font-family: 'Oswald', sans-serif;
    @include fluid-type(360px,
      1440px,
      18px,
      22px);
    line-height: 130%;
    font-weight: 400;
  }
  p{
    font-size: 1rem;
    text-indent: 0;
  }
  .error{
    border-color: #9F3A38;
    background-color: lighten(#9F3A38, 50%);
  }
  .loading,
  .submitteds{
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .3s ease;
  }
  .slide-fade-enter, .slide-fade-leave-to{
    transform: translateX(60px);
    opacity: 0;
  }


</style>
